import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user } = useAuth();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="app-container">
      <Sidebar collapsed={sidebarCollapsed} onClose={toggleSidebar} />
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        <Header 
          onToggleSidebar={toggleSidebar}
          user={user}
        />
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
